<app-chat-tab-shell
    [contractId]="contractId()"
    [comparisonId]="comparisonId()"
    [compareDocuments]="compareDocuments()"
    [kpiDocuments]="kpiDocuments()"
    [documentTypeId]="documentTypeId()"
    [projectId]="projectId()"
    [embeddingsStatus]="embeddingsStatus()"
/>
